/*----------------------------------------------------------------------------
|
|   Simple convienent to get/set user settings with (asynchronous)
|   persistent on server side.
|
|
|   Usage:
|
|   // initial load  
|   UserSettings.load()
|     or
|   UserSettings.load( function() { ... } );
|
|
|   // gives the complete settings object:
|   var all = UserSettings.get()
|
|
|   // gives back only sub tree:
|   var lastProfile = UserSettings.get('backlog.lastProfile'); 
|
|
|   // sets/overwrites with value 'fooBar':
|   UserSettings.set('backlog.lastProfile', 'fooBar'); 
|                                
|
|   var myFavorites = [ 'one', 'two', { name: 'fo', id: 42 } ]
|
|   UserSettings.set('favorites', myFavorites);
|
|
|   // does a set and updates immediately on server side:
|   UserSettings.update('favorites', myFavorites);
|
|
|   // save all settings to server side
|   UserSettings.save()
|   UserSettings.save( function() { ... } );
|
|
|
|
|   Jochen Loewer,
|   July 2014
|
\----------------------------------------------------------------------------*/
UserSettings = {
  url: "/os/ossui/v1/in/usersettings",
  get: function(path) {
    if (!path || path == '') return this.val;
    var ps = path.split('.'), co = this.val; 
    for (var i = 0; i < ps.length; i++) { 
      co = (co[ps[i]])? co[ps[i]] : co[ps[i]] = {}; 
    } 
    return co; 
  },
  set: function(path, value) {
    if (!path || path == '') {
      this.val = value;
      return;
    }
    var ps = path.split('.'), co = this.val, key;
    for (var i = 0; i < ps.length; i++) {
      if (key) co = (co[key]? co[key] : co[key] = {});
      key = ps[i];
    }
    co[key] = value; 
  },
  load: function(cb, errcb) {
    var self = this;
    GET(this.url,'', function(data) {
      //console.log('UserSettings.load:', data);
      if (typeof data.code !== 'undefined' && data.code == 401) {
          //console.log('401 coming - ', data);
          cb(data);
          return;
      }
      self.val     = data.user_setting;
      self.user_id = data.user_id;
      self.tenant  = data.tenant;
      self.config  = data.config;             
      self.groups  = data.groups;             
      self.levels  = data.levels;             
      if (cb) {
        cb(data.user_setting);
      }
    }, function(statusText, errObj, respText) {
      if (errcb) {
        errcb(statusText, errObj, respText);
      }
    });
  },
  update: function(path, value, cb) {
    if (value == undefined) {
      value = this.get(path);
    }
    this.set(path, value);           
    PUT(this.url+'/'+path, value, function(data) {
      //console.log('UserSettings.update:', data);
      if (cb) {
        cb(data.user_setting);
      }
    });           
  },
  save: function(cb) {
    PUT(this.url, this.val, function(data) { 
      //console.log('UserSettings.save:', data);
      if (cb) {
        cb(data.user_setting);
      }
    });    
  },
  acvClause: function (and, field, level) {
     var clause = and+' ( '+field
     var acvList = this.validAcvs(level)
     if ( acvList.length == 0 || acvList.indexOf('WW') >= 0 ) {
       return ''
     }
     if ( acvList.length == 1 ) {
       clause += ' = '+acvList[0]+' '
     } else {
       clause += " in ('"
       var tick = ''
       for (var i=0; i < acvList.length; i++) {
         clause += tick+acvList[i]
         tick = "','"
       }
       clause += "') "
     }
     return clause
  },
  isValidAcv: function (acv, level) {
    if (this.tenant == '') this.tenant = GlobalUserSettings.tenant
    if (this.tenant == 'HPQ') this.tenant = 'HPI'

    if (this.levels != undefined && (this.levels['WW-'+this.tenant] >= level || this.levels[acv+'-'+this.tenant] >= level)) {
      return true;
    }
    return false;
  },
  validAcvs: function (acvLevel) {
    var acvList = [];
    for (var key in this.levels) {
      if (this.levels.hasOwnProperty(key) && this.levels[key] >= acvLevel) {
        keyparts = key.split('-');
        if (keyparts[1] == this.tenant) {
          acvList.push(keyparts[0])
        }
      }
    }
    return acvList
  },
  acvLevel: function (acv) {
    for (var i=0; i < this.levels.length; i++) {
      if (this.levels[i]['acv'] >= acv) {
        if (this.levels[i]['tenant'] == this.tenant) {
          return this.levels[i]['level']
        }
      }
    }
    return 0
  },
  memberOf: function (groupOrGroups) {
    if (groupOrGroups instanceof Array) {
      for (var i=0; i < groupOrGroups.length; i++) {
        if (this.groups.indexOf( groupOrGroups[i] ) >= 0) return true;
      }
    } else {
      if (this.groups.indexOf( groupOrGroups ) >= 0) return true;      
    }
  },
  val: {},
  user_id: "",
  tenant: "",
  groups: [],
  levels: [],
  config: {}
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = UserSettings;
}
